import React from "react";

export default function TopContactBar() {
  return (
    <div className="top-contact-bar">
      <div className="top-contact-inner">

        <span>
          For Appointments:{" "}
          <a href="tel:+919573152875">+91 9573152875</a>
        </span>

        <span>
  For an Expert / Second Opinion{" "}
  <a
    href="https://wa.me/917842170179"
    target="_blank"
    rel="noopener noreferrer"
  >
    Contact in WhatsApp or Text: +91 7842170179
  </a>
</span>

        <span>
          Email:{" "}
          <a href="mailto:handandwristclinics@gmail.com">
            handandwristclinics@gmail.com
          </a>
        </span>

      </div>
    </div>
  );
}